import { SidePanel } from '@ui/layout';
import { useDesignPanelScope } from './hooks/use-design-panel-scope.hook';
import { ProgramDonutChart } from './ProgramDonutChart';

export const Results: React.FC = () => {
  const { activityMix, nia, totalGfa } = useDesignPanelScope();

  return (
    <SidePanel.Content.Section>
      <ProgramDonutChart programs={activityMix} totalGfa={totalGfa} nia={nia} />
    </SidePanel.Content.Section>
  );
};
